export const ErrorMessage = {
  title: 'Something went wrong.',
  description: 'If the problem persists, please contact us',
};
